import { render } from "./ToolbarButtonSavedFilters.vue?vue&type=template&id=4fbb0ec7&scoped=true"
import script from "./ToolbarButtonSavedFilters.vue?vue&type=script&lang=js"
export * from "./ToolbarButtonSavedFilters.vue?vue&type=script&lang=js"

import "./ToolbarButtonSavedFilters.vue?vue&type=style&index=0&id=4fbb0ec7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbb0ec7"]])

export default __exports__